import T from 'utils/T';
import ex from 'utils/ex';

import './Badge.css';
export default function Badge(props) {
  const {
    count,
    ...rest
  } = props || {};
  return (
    <div {...ex('Badge', rest)}>
      {count}
    </div>
  );
}
